import Button from '@material-ui/core/Button'
import { useState } from 'react'
import SettingsIcon from '@material-ui/icons/Settings'
import { useTranslation } from 'react-i18next'

import SettingsDialog from './SettingsDialog'

export default function SettingsDialogButton({ isOffline, isLoading }) {
  const { t } = useTranslation()
  const [isDialogOpen, setIsDialogOpen] = useState(false)

  const handleClickOpen = () => setIsDialogOpen(true)
  const handleClose = () => setIsDialogOpen(false)

  return (
    <>
      <Button
        className='header-action'
        disabled={isOffline || isLoading}
        onClick={handleClickOpen}
        variant='outlined'
        size='small'
        startIcon={<SettingsIcon />}
      >
        <span className='action-label'>{t('SettingsDialog.Settings')}</span>
      </Button>

      {isDialogOpen && <SettingsDialog handleClose={handleClose} />}
    </>
  )
}
